import { toast } from "sonner";
import { usePatcher } from "@/hooks/usePatcher";
import { useSettings } from "@/hooks/useSettings";
import Titlebar from "@/components/launcher/Titlebar";
import StatusWidget from "@/components/launcher/StatusWidget";
import NewsPanel from "@/components/launcher/NewsPanel";
import QuickLinks from "@/components/launcher/QuickLinks";
import PatchPanel from "@/components/launcher/PatchPanel";

const BG = "/assets/koselig-hero.jpg";
const preview = (description) => toast("Tryb podglądu", { description });

const Backdrop = () => (
  <>
    <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" data-testid="launcher-bg-logo" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#05060f]/90 via-[#05060f]/55 to-[#05060f]/30" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#05060f]/80 via-transparent to-transparent" />
    <div className="grain absolute inset-0 pointer-events-none" />
  </>
);

export default function Launcher() {
  const settings = useSettings({ server_name: "Metin2" });
  const { state, isHost, check, start, config, post } = usePatcher();
  const configName = settings.config_exe || "Konfiguracja.exe";

  const onStart = () => (isHost ? start() : preview("W kliencie C# ten przycisk uruchomi grę."));
  const openLink = (url) => (isHost ? post({ type: "open", url }) : window.open(url, "_blank"));
  const openConfig = () => (isHost ? config(settings.config_exe) : preview(`W kliencie C# otworzy się ${configName}.`));
  const frame = isHost ? "h-screen" : "max-w-[920px] h-[580px] rounded-xl border border-slate-500/40 shadow-[0_0_60px_rgba(80,100,230,0.18)]";

  return (
    <div className={`min-h-screen bg-[#05060a] flex items-center justify-center ${isHost ? "" : "p-6"}`}>
      <div className={`relative w-full overflow-hidden bg-[#05060f] ${frame}`} data-testid="launcher-window">
        <Backdrop />
        <div className="relative flex flex-col h-full">
          <Titlebar name={settings.server_name} post={post} />
          <div className="grid grid-cols-12 gap-6 p-6 flex-1 min-h-0">
            <div className="col-span-7 flex flex-col min-h-0 launcher-rise">
              <h1 className="font-display text-4xl font-bold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-amber-100 via-amber-300 to-amber-600 mb-1" data-testid="launcher-server-name">{settings.server_name}</h1>
              <p className="text-xs text-slate-500 mb-5 tracking-wide">Aktualności i zmiany na serwerze</p>
              <NewsPanel />
            </div>
            <div className="col-span-5 flex flex-col gap-4 launcher-rise" style={{ animationDelay: "120ms" }}>
              <StatusWidget />
              <QuickLinks settings={settings} openLink={openLink} openConfig={openConfig} />
              <PatchPanel state={state} isHost={isHost} onCheck={check} onStart={onStart} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
